import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import FindADealer from '../../../3_Organisms/FindADealer/FindADealer'
import { languageController } from '../../../../controllers/language/languageController'

function FindDealerStep_BaSA({
  handleNextStep,
}) {

  const MemoFindADealer = useMemo(() => {
    return (
      <FindADealer
        isStepRenderType={true}
        onSelectDealer={(data) => handleNextStep({ dealerData: data })}
      // TODO: Needs to handle the EV flag?
      // isEVonly={desiredVehicleData.isEV ? true : false}
      />
    );
  }, []);

  return (
    <div className="mz-find-dealer-step-basa">
      <h5 className="mz-find-dealer-step-basa__title">{languageController.getCopy('bookServiceAppointment', 'step3Title')}</h5>
      {MemoFindADealer}
    </div>
  )
}

FindDealerStep_BaSA.propTypes = {
  handleNextStep: PropTypes.func.isRequired,
}

export default FindDealerStep_BaSA